var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-flag"},[(_vm.countryCode)?_c('img',{attrs:{"alt":_vm.countryCode,"src":_vm.flagUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }